export const DEBUG = false;

// 'https://clarendonqldtest.rendivo.com'
// 'https://clarendonnswtest.rendivo.com'
// 'https://carlisletest.rendivo.com';
export const DEBUG_URL = 'https://clarendonnsw.rendivo.com';

export const getBaseURL = () => (DEBUG ? DEBUG_URL : `${window.location.protocol}//${window.location.hostname}`);

export const getBasicAuthData = () => {
  /**
   * BRIC:bEzEjgYZJUC4Fzj4BaNDAzUcquLS92jQ
   * CRGNSW:Eg2AgK6rNsgcwFbXBnuHCRP9aUzPjq5n
   * DOMQLD:sGjeZeJa7rrvsWXAB892u3vDJnhWE4tR
   *
   */

  // const authUser = 'DOMQLD';
  // const authKey = 'sGjeZeJa7rrvsWXAB892u3vDJnhWE4tR';
  const authUser = '';
  const authKey = '';
  const encoded = btoa(`${authUser}:${authKey}`);
  return ['Authorization', `Basic ${encoded}`];
};
